import React from 'react';
import {MENUS} from '../../../../../../utils/query_utils';
import DatasetAttributeInput from '../dataset_attribute_input';
import DatasetAttributeComponent from '../dataset_attribute';

export default class DimensionAttribute extends DatasetAttributeComponent {
    canRemove() {
        return this.props.attribute.column;
    }

    renderAttribute() {
        const {attribute, firstInList} = this.props;
        return (
            <>
                <DatasetAttributeInput
                    attribute={attribute}
                    propName="column"
                    valueProp="fullName"
                    placeholder={!firstInList && !attribute.column ? '+' : 'genre name'}
                    menu={MENUS.COLUMN}
                    ref={(el) => { this.columnInput = el; }}
                />
            </>
        )
    }
}
